/**
 * Returns the fallback only if the value is strictly undefined.
 *
 * Less optimal than `??` because it needs to fully evaluate both
 * value and fallback. But there is no other option in JS.
 *
 * @param {*} value - The value to check.
 * @param {*} fallback - The value to return if input is undefined.
 * @returns {*} - Either the original value or the fallback.
 */
export const ifUndefined = <T, U>(value: T | undefined, fallback: U): T | U =>
  value === undefined ? fallback : value;
